export function useModal(): {
    readonly isVisible: Ref<boolean>
    openModal: () => void
    closeModal: () => void
} {
    const isVisible: Ref<boolean> = ref(false)

    const openModal = (): void => {
        isVisible.value = true
    }

    const closeModal = (): void => {
        isVisible.value = false
    }

    return {
        isVisible,
        openModal,
        closeModal,
    }
}
